import LetterAvatar from "@/components/Avatar/LetterAvatar"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import StatusBadge from "@/components/ui/badge"
import CodeFormat from "@/components/ui/code"
export const columns = [
  {
    header: "Name",
    accessorKey: "value",
  },
]
